import Header from "./AppHeader";
import { push, goBack } from "connected-react-router";
import { connect } from "react-redux";

interface State {
  router?: {
    location?: Location;
  };
}

interface MapStateToProps {
  pathname: string;
}

export const mapStateToProps = (state: State): MapStateToProps => {
  return {
    pathname: state.router.location.pathname
  };
};

export default connect(mapStateToProps, { push, goBack })(Header);
